import { HiArrowsRightLeft, HiArrowSmallUp } from 'react-icons/hi2'
import { cn } from '../../libs/utils'

export function Indicator({ up, className = 'tw-bg-[#DFF3FE] tw-text-[#015C89]' }) {
	if (up) {
		return <HiArrowSmallUp className={cn(`tw-w-[26px] tw-h-[26px] tw-rounded-full tw-p-1`, className)} />
	}

	return <HiArrowsRightLeft className={cn(`tw-w-[26px] tw-h-[26px] tw-rounded-full tw-p-1`, className)} />
}
